
class AccordionItem
{
    public readonly rootElement: HTMLElement;
    public readonly headerElement: HTMLElement;

    private _collapsed: boolean;


    constructor(rootElement: HTMLElement)
    {
        const headerElement = rootElement.querySelector("[data-accordion-header]");
        if (headerElement === null)
        {
            throw new Error("Accordion item does not contain a header element");
        }

        this.rootElement = rootElement;
        this.headerElement = headerElement as HTMLElement;
        this._collapsed = true;
    }

    public get collapsed(): boolean
    {
        return this._collapsed;
    }

    public set collapsed(collapsed: boolean)
    {
        if (this._collapsed !== collapsed)
        {
            if (collapsed)
            {
                this.rootElement.dataset.collapsed = "";
            }
            else
            {
                this.rootElement.dataset.transparent = "";
                delete this.rootElement.dataset.collapsed;
                requestAnimationFrame(() => delete this.rootElement.dataset.transparent);
            }
            this._collapsed = collapsed;
        }
    }
}

interface AccordionEventListeners
{
    onClick: EventListener;
}


export class AccordionService
{
    public readonly rootElement: HTMLElement;

    private readonly eventListeners: AccordionEventListeners;
    private readonly items: AccordionItem[];

    private eventSubscription: boolean;

    constructor(rootElement: HTMLDivElement)
    {
        this.rootElement = rootElement;

        this.items = Array.from(this.rootElement.querySelectorAll("[data-accordion-item]")).map(e => new AccordionItem(e as HTMLElement));

        this.eventListeners = {
            onClick: this.handleClick.bind(this) as EventListener,
        };

        this.eventSubscription = false;

        this.subscribe();
    }

    public dispose(): void
    {
        this.unsubscribe();
    }

    private handleClick(event: MouseEvent): void
    {
        const target = event.target as HTMLElement;

        const item = this.items.find(e => e.headerElement.contains(target));
        if (item !== undefined)
        {
            event.stopImmediatePropagation();
            item.collapsed = !item.collapsed;
            return;
        }
    }

    private subscribe()
    {
        if (!this.eventSubscription)
        {
            document.addEventListener("click", this.eventListeners.onClick, true);
            this.eventSubscription = true;
        }
    }

    private unsubscribe()
    {
        if (this.eventSubscription)
        {
            document.removeEventListener("click", this.eventListeners.onClick, true);
            this.eventSubscription = false;
        }
    }
}